module.exports = __webpack_public_path__ + "img/pic_KK1.fa80ac80.png";